import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Key, Building2, Tag, MessageSquare, PhoneCall, Activity, LogOut, ShieldUser } from "lucide-react";
import { useAdminAuth } from "../context/AdminAuthContext";
import { ADMIN } from "../constants/testIds";

const navItems = [
  { to: "/sp-command-center", end: true, icon: LayoutDashboard, label: "Dashboard", testId: ADMIN.sidebarDashboard },
  { to: "/sp-command-center/users", icon: Users, label: "Users", testId: ADMIN.sidebarUsers },
  { to: "/sp-command-center/access-codes", icon: Key, label: "Access Codes", testId: ADMIN.sidebarAccessCodes },
  { to: "/sp-command-center/properties", icon: Building2, label: "Properties", testId: ADMIN.sidebarProperties },
  { to: "/sp-command-center/categories", icon: Tag, label: "Categories", testId: ADMIN.sidebarCategories },
  { to: "/sp-command-center/leads", icon: PhoneCall, label: "Leads", testId: ADMIN.sidebarLeads },
  { to: "/sp-command-center/inquiries", icon: MessageSquare, label: "Inquiries", testId: ADMIN.sidebarInquiries },
  { to: "/sp-command-center/activity", icon: Activity, label: "Activity", testId: ADMIN.sidebarActivity },
  { to: "/sp-command-center/admins", icon: ShieldUser, label: "Admin Users", testId: ADMIN.sidebarAdmins },
];

export default function AdminLayout() {
  const { admin, adminLogout } = useAdminAuth();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-zinc-50 font-sans">
      {/* Sidebar */}
      <aside className="w-56 bg-white border-r border-zinc-200 flex flex-col fixed h-full z-40" data-testid={ADMIN.sidebar}>
        {/* Brand */}
        <div className="px-5 py-4 border-b border-zinc-100 flex flex-col items-center">
          <img
            src="https://customer-assets.emergentagent.com/job_investment-portal-38/artifacts/xmvknh92_Green%20and%20Gold%20Professional%20Letter%20A%20Logo%20%281%29.png"
            alt="Scarlet Properties"
            className="w-28 h-auto"
          />
          <div className="text-[8px] tracking-[0.4em] text-zinc-400 uppercase mt-1">CMS</div>
        </div>

        {/* Nav */}
        <nav className="flex-1 py-4 overflow-y-auto">
          {navItems.map(({ to, end, icon: Icon, label, testId }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-5 py-2.5 text-xs tracking-wider transition-all duration-150 ${
                  isActive
                    ? "text-[#C8102E] bg-red-50 font-medium border-r-2 border-[#C8102E]"
                    : "text-zinc-500 hover:text-zinc-900 hover:bg-zinc-50"
                }`
              }
            >
              <Icon size={14} strokeWidth={1.5} />
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="px-5 py-4 border-t border-zinc-100">
          <div className="text-[10px] text-zinc-400 mb-2 truncate">{admin?.email}</div>
          <button
            onClick={() => { adminLogout(); navigate("/sp-command-center/login"); }}
            data-testid={ADMIN.logoutBtn}
            className="flex items-center gap-2 text-xs text-zinc-400 hover:text-[#C8102E] transition-colors"
          >
            <LogOut size={13} strokeWidth={1.5} />
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 ml-56 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
